$(document).ready(function () {
const params = new URLSearchParams(window.location.search);
const errorEl = document.querySelector("#ContactFooter-error");

if (errorEl) {
  errorEl.style.display =
    params.get("form_type") === "contact" ? "none" : "block";
}

  $(".banners_list").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });
  $(".categories-slider").slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 5
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  $(".review-slider").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });

  

  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1
        }
      }
    ]
  });
  

  $(document).on('click','.accordion details',function(e) {
    // Don't toggle accordion when clicking links inside the answer content
    if($(e.target).closest('.accordion__content').length && $(e.target).closest('a').length){
      return;
    }
    e.preventDefault();
    if($(this).attr('open')){
     $(this).attr('open', false);
    }else{
      $('.accordion details').attr('open', false);
      $(this).attr('open', true);
    }
  });
});


// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");



// popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');
  
      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });
  
  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });
  
  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }
});

// quantity set 1 automatically 

// const qtyInput = document.querySelector("quantity-input .quantity__input");

const qtyInput = document.querySelector("quantity-input .quantity__input");

qtyInput ?qtyInput.addEventListener("blur", function () {
  const val = parseInt(this.value, 10);

  if (!this.value || val === 0 || isNaN(val)) {
    this.value = 1;
  }
}) : '';

// Video lazy-loading with Intersection Observer
// Pauses videos when they leave the viewport, plays when they enter
// Saves bandwidth and improves performance on pages with multiple videos
(function() {
  'use strict';

  // Only run if Intersection Observer is supported
  if (!('IntersectionObserver' in window)) return;

  // Select all video elements on the page
  const videos = document.querySelectorAll('video');

  if (!videos.length) return;

  // Track which videos are in the viewport
  const videoVisibility = new Map();

  // Create the observer
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting) {
        // Video is in viewport - play it
        videoVisibility.set(video, true);

        // Only play if the video has a source and is not already playing
        if (video.readyState >= 2 && video.paused) {
          video.play().catch(() => {
            // Autoplay was prevented - this is expected for non-muted videos
            // Silent catch to avoid console errors
          });
        }
      } else {
        // Video left viewport - pause it to save bandwidth
        videoVisibility.set(video, false);

        if (!video.paused) {
          video.pause();
        }
      }
    });
  }, {
    // Start observing when video is 50px outside viewport
    rootMargin: '50px 0px',
    // Consider video "visible" when at least 25% is in viewport
    threshold: 0.25
  });

  // Observe all videos
  videos.forEach(video => {
    videoObserver.observe(video);
    videoVisibility.set(video, false);
  });

  // Clean up observer when page is unloaded
  window.addEventListener('beforeunload', () => {
    videoObserver.disconnect();
  });
})();